import {Link, useRouteError} from "react-router-dom";
import {Typography, Layout, Col, Row, Button, Result, Card} from 'antd';


const {Paragraph, Text} = Typography;
const {Content, Header} = Layout;

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <Layout style={{height: "100vh"}}>
            <Header style={{display: 'flex', width: '100%'}}>
                <Row gutter={16}>
                    <Col className="gutter-row" span={24}>
                        <div>
                            <div className="logo" style={{color: '#ffffff', fontWeight: 'bold'}}>BERGER auto import
                            </div>
                        </div>
                    </Col>
                </Row>
            </Header>
            <Content style={{display: 'flex', alignItems: 'center', maxWidth: '1200px', width: '100%', margin: 'auto'}}>
                <Row gutter={16}>
                    <Col className="gutter-row" span={12} offset={6}>
                        <Card>
                            <Result
                                status="warning"
                                title="There are some problems with your operation."
                                extra={
                                    <>
                                        <Typography>
                                            <Paragraph>
                                                <Text code>{error.statusText || error.message}</Text>
                                            </Paragraph>
                                        </Typography>
                                        <Link to="/">
                                            <Button type="primary" key="home">
                                                Go to home
                                            </Button>
                                        </Link>
                                    </>
                                }
                            />
                        </Card>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}